import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  item: {
    // display: 'flex',
    width: '100%',
    alignSelf: 'center',
    justifyContent: 'center',
    height: '100%',
    padding: '15px 30px 5px 30px',
    '& .MuiFormHelperText-contained': {
      margin: '0',
    },
  },
  helperRow: {
    height: '15px',
    fontFamily: 'Roboto',
    fontSize: '12px',
    // marginTop: '3px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  fieldLimits: {
    textAlign: 'right',
    color: '#2C2D3E',
  },
  error: {
    color: 'red',
  },
}));
